import React from "react";
import classNames from "classnames";
import Icon from "components/icon/Icon";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

import "./badge.scss";

export type TBadgeType =
  | "primary"
  | "success"
  | "warning"
  | "error"
  | "gray"
  | "grayblue"
  | "public"
  | "lightblue"
  | "lightgray";

export interface IBadgeProps {
  className?: string;
  type?: TBadgeType;
  size?: "xsmall" | "small" | "medium" | "large";
  iconLeft?: React.ReactNode;
  iconSize?: string;
  iconRight?: React.ReactNode;
  icon?: IconProp;
  children?: React.ReactNode;
  outline?: boolean;
  onClick?: React.MouseEventHandler<HTMLElement>;
  colour?: string;
  backgroundColour?: string;
}

export const Badge: React.FC<IBadgeProps> = props => {
  const { className, children } = props;

  const classes = classNames(`ui-badge ${className ?? ""}`, {
    "ui-badge_primary": props.type === "primary",
    "ui-badge_success": props.type === "success",
    "ui-badge_warning": props.type === "warning",
    "ui-badge_error": props.type === "error",
    "ui-badge_gray": props.type === "gray",
    "ui-badge_grayblue": props.type === "grayblue",
    "ui-badge_lightgray": props.type === "lightgray",
    "ui-badge_public": props.type === "public",
    "ui-badge_lightblue": props.type === "lightblue",

    "ui-badge_xsmall": props.size === "xsmall",
    "ui-badge_small": props.size === "small",
    "ui-badge_medium": props.size === "medium",
    "ui-badge_large": props.size === "large",

    "ui-badge_outline": props.outline,
  });

  const styleFromProps =
    props.colour !== undefined || props.backgroundColour !== undefined
      ? { borderColor: props.colour, color: props.colour, backgroundColor: props.backgroundColour }
      : undefined;

  const content = (
    <>
      {props.iconLeft ? (
        <span
          className={classNames("ui-badge_icon ui-badge_icon-left", {
            "ui-badge_icon-small": props.iconSize === "small",
            "ui-badge_icon-medium": props.iconSize === "medium",
            "ui-badge_icon-large": props.iconSize === "large",
          })}
        >
          {props.iconLeft}
        </span>
      ) : null}
      {children}
      {props.iconRight ? (
        <span className="ui-badge_icon ui-badge_icon-right">
          <Icon icon={props.icon} size="xsmall" />
        </span>
      ) : null}
    </>
  );

  if (props.onClick) {
    return (
      <button type="button" className={classes} onClick={props.onClick} style={styleFromProps}>
        {content}
      </button>
    );
  }

  return (
    <span className={classes} style={styleFromProps}>
      {content}
    </span>
  );
};
